import React, { useState, useEffect } from 'react';

const FightInfo = ({ text, removeInfo, ID }) => {

    const [textInfo, setTextInfo] = useState("");
    const [disappearAnimation, setDisappearAnimation] = useState(null);
 
    useEffect(() => {
        animateText(text.text);
    }, []);
 
    const removeAfterDelay = event => {
        const eventElement = event.currentTarget;
        
        setTimeout(() => {
            setDisappearAnimation("disappear")
            setTimeout(() => {
                eventElement.remove();
            }, 500);
        }, 5000);
    }

    const animateText = (text) => {
        const splittedText = text.split(""); 
        let currentText = "";
        let index = 0;
        const animateSpeed = (100 / (splittedText.length / 4));
        const anim = setInterval(() => {
            currentText += splittedText[index];
            setTextInfo(currentText);
            if (currentText.length === splittedText.length) {
                clearInterval(anim);
            } 
            index++;    
        }, animateSpeed);
    }

    return (
        <p className={`Description-text ${disappearAnimation}`} index={ID} onAnimationEnd={removeAfterDelay}>
            {textInfo}
        </p>
    );
}

export default FightInfo;